// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2pd-p","inputWrap":"styles_inputWrap__eP0qt","input":"styles_input__1yLqU"};